import request, { getAccessToken } from '@/sheep/request';
import { baseUrl, apiPath, tenantId } from '@/sheep/config';

const OperationOrderApi = {
  getOrderPage: async (params) => {
    return request({
      url: '/operation/order/page',
      method: 'GET',
      params,
      custom: {
        showLoading: false,
        showError: false,
      },
    });
  },

  getOrder: async (id) => {
    return request({
      url: '/operation/order/get',
      method: 'GET',
      params: { id },
      custom: {
        showLoading: false,
        showError: true,
      },
    });
  },

  applyRefund: async (data) => {
    return request({
      url: '/operation/pay/refund/apply',
      method: 'POST',
      params: {
        orderId: data.orderId,
        refundReason: data.refundReason || data.reason,
      },
      custom: {
        showLoading: true,
        showError: true,
      },
    });
  },

  // 统计当前订单数
  getOrderCount: async () => {
    return request({
      url: '/operation/order/count',
      method: 'GET',
      custom: {
        showLoading: false,
        showError: true,
      },
    });
  },
  // 获得订单测评信息
  getOrderAssessmentInfo: async (id) => {
    return request({
      url: '/operation/order/assessment-info',
      method: 'GET',
      params: { id },
      custom: {
        showLoading: false,
        showError: true,
      },
    });
  },

  // 获得多模态测评报告
  getMultimodalReport: async (orderId) => {
    return request({
      url: '/operation/order/multimodal-report',
      method: 'GET',
      params: { orderId },
      custom: {
        showLoading: false,
        showError: true,
      },
    });
  },

  // 通过视频ID获得多模态测评报告
  getMultimodalReportByVideoId: async (videoId) => {
    return request({
      url: '/operation/order/multimodal-report-by-video',
      method: 'GET',
      params: { videoId },
      custom: {
        showLoading: false,
        showError: true,
      },
    });
  },

  // 上传订单文件（视频等）
  uploadFile: (filePath, orderId) => {
    return new Promise((resolve, reject) => {
      // #ifdef H5
      // H5 端：支持 Blob/File/FormData（录制视频产生的 Blob 数据）
      if (
        filePath instanceof FormData ||
        filePath instanceof File ||
        filePath instanceof Blob
      ) {
        const formData = filePath instanceof FormData ? filePath : new FormData();
        if (!(filePath instanceof FormData)) {
          formData.append('file', filePath, 'video.mp4');
        }
        formData.append('orderId', orderId);
        fetch(baseUrl + apiPath + '/operation/order/file/upload', {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: getAccessToken() ? `Bearer ${getAccessToken()}` : '',
            'tenant-id': tenantId,
          },
        })
          .then((res) => res.json())
          .then((data) => {
            if (data && data.code !== 0) {
              reject(data);
              return;
            }
            resolve(data);
          })
          .catch(reject);
        return;
      }
      // #endif

      // 非 H5 端：使用 uni.uploadFile
      uni.uploadFile({
        url: baseUrl + apiPath + '/operation/order/file/upload',
        filePath,
        name: 'file',
        header: {
          Accept: '*/*',
          'tenant-id': tenantId,
          Authorization: 'Bearer ' + getAccessToken(),
        },
        formData: {
          orderId: String(orderId),
        },
        success: (res) => {
          const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
          if (data.code !== 0) {
            reject(data);
            return;
          }
          resolve(data);
        },
        fail: reject,
      });
    });
  },
};

export default OperationOrderApi;
